import { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { resendVerification } from '../store/authSlice';

export default function VerifyEmailSent() {
  const location = useLocation();
  const dispatch = useDispatch();
  const email = location.state?.email;
  const { loading, verificationMessage, error } = useSelector((state) => state.auth);
  const [resent, setResent] = useState(false);

  const handleResend = () => {
    if (email) {
      dispatch(resendVerification(email));
      setResent(true);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-form" style={{ textAlign: 'center' }}>
        <h2>Check your email</h2>
        <p style={{ color: '#bbb', fontSize: 15, lineHeight: 1.6 }}>
          We sent a verification link to <strong style={{ color: '#C8963E' }}>{email}</strong>.
          Click the link to activate your account.
        </p>
        {error && <div className="error-msg">{error}</div>}
        {resent && verificationMessage && (
          <p style={{ color: '#5B8C7A', fontSize: 14 }}>{verificationMessage}</p>
        )}
        <button
          onClick={handleResend}
          disabled={loading}
          className="btn btn-outline"
          style={{ marginTop: 16 }}
        >
          {loading ? 'Resending...' : 'Resend email'}
        </button>
        <p className="auth-link" style={{ marginTop: 20 }}>
          <Link to="/login">Back to login</Link>
        </p>
      </div>
    </div>
  );
}
